<ion-card
  *ngIf="userInfo"
  class="ion-margin mart24 border-r10 {{
    userInfo?.subscribedTier?.tier?.toLowerCase() === 'premium'
      ? 'premium'
      : 'lite'
  }}"
>
  <ion-card-content
    class="d-flex flex-col ion-align-items-start ion-justify-content-between"
  >
    <div class="tx-logo">
      <ion-img [src]="userInfo?.subscribedTier?.icon"></ion-img>
    </div>
    <div class="userinfo">
      <h2 class="fs-4 l-height27 font700">{{ userInfo?.fullName || userInfo?.firstName }}</h2>
      <h4 class="fs-2 l-height21 font500">{{ userInfo?.mobileNo }}</h4>
    </div>
    <div class="w100 card-footer">
      <span class="tierinfo ion-float-start ion-text-capitalize fs-1 font500">
        {{ userInfo?.subscribedTier?.tierTitle ||  userInfo?.subscribedTier?.tier}}
        <ion-icon class="marl4 marr4 member-rating-icon" name="star"></ion-icon>
        <ion-icon class="marl4 marr4 member-rating-icon" name="star"></ion-icon>
        <ion-icon class="marl4 marr4 member-rating-icon" name="star"></ion-icon>
      </span>
      <span class="validity ion-float-end fs-2 font400">
        {{ "home.user_card.user_validity" | translate }}
        {{ expiryDate | smartdate : "mediumDate" }}
      </span>
    </div>
  </ion-card-content>
</ion-card>
